import { Link } from "react-router-dom";

export function Header() {
  return (
    <header className="h-[100px] w-full bg-white flex gap-10 items-center justify-center shadow">
      <Link to="/">
        <img
          src="/assets/brand/logo-balzac.svg"
          alt="relais colis"
          className="max-w-[133px] w-full"
        />
      </Link>
    </header>
  );
}
